import SignUpService from "@services/sign-up-service";
import { getSingleInstanceByElement, getSingleInstanceByName, initialiseComponents } from "../../core";
import Component from "../component.abstract";
import ValidatedInput from "../form/validated-input/validated-input";
import { notifyFromAlert } from "../helpers/notifs";
import SuggestInput from "../inputs/autocomplete/autocomplete";
import ValidatedCheckBoxGroup from "../inputs/group/checkbox/validated-checkbox";
import SimplePassword from "../inputs/password/simple-password";
import SignIn from "./sign-in";
import { ACCOUNT_CREATION_SUCCESS } from "@controllers/validation/email_confirmation/email_confirmation_controller";

interface SignUpProps {
  contractTypes: JSON
  url: string;
  site: string;
  regexpEmail: string;
  links: Links;
}

interface Links {
  [index: string]: any;
  linkedin: string;
  google: string;
  facebook: string;
  cgu: string;
  confidentialite: string;
}

export default class SignUp extends Component {
  private saveButton: HTMLButtonElement;
  private firstname: HTMLInputElement;
  private firstnameValidator: ValidatedInput;
  private name: HTMLInputElement;
  private nameValidator: ValidatedInput;
  private email: HTMLInputElement;
  private emailValidator: ValidatedInput;
  private password: SimplePassword;
  private job: SuggestInput;
  private locality: SuggestInput;
  private localityValidator: ValidatedInput;
  private signIn: SignIn;
  private contractTypes : any;
  private contractsContainer: HTMLElement;
  private contractValidator: ValidatedCheckBoxGroup;


  constructor(private props: SignUpProps, element: HTMLElement) {
    super(props, element);
    this.contractTypes = this.props.contractTypes
  }

  mounted(): void {
    this.signIn = getSingleInstanceByName("SignIn");

    this.saveButton = this.element.querySelector(".profile-button");
    // Set header message
    if (this.props.site) {
      this.element.querySelector("[data-sf-title]").innerHTML =
        "En vous inscrivant à " +
        this.props.site +
        ", nous vous aidons à trouver VOTRE job&nbsp;:<br>" +
        "<strong>Offres personnalisées, gestion des candidatures, messages directs des recruteurs...</strong>";
    }
    // Set dynamic link
    if (this.props.links) {
      this.element.querySelectorAll("[data-sf-link]").forEach((link) => {
        link.setAttribute(
          "href",
          this.props.links[link.getAttribute("data-sf-link")]
        );
      });
    }
    // Get input fields
    this.firstname = this.element.querySelector("[name=firstname]");
    this.name = this.element.querySelector("[name=name]");
    this.email = this.element.querySelector("[name=email]");
    this.email.setAttribute(
         "data-val-regex-pattern",
         this.props.regexpEmail.replace("&quot;", '"')
    );

    initialiseComponents();

    // Get password input
    this.password = getSingleInstanceByElement(
      "SimplePassword",
      this.element.querySelector("[data-simple-password]")
    );

    this.job = getSingleInstanceByElement("SuggestInput", this.element.querySelector("input[data-autocomplete][name=job]"));
    this.locality = getSingleInstanceByElement("SuggestInput", this.element.querySelector("#locality"));
    
    this.contractsContainer = this.element.querySelector('.profile-form-row-field-contracts-container');
    this.contractsContainer.innerHTML = "";
    if (this.props.contractTypes) {
      this.contractTypes.forEach((contract: any) => {
        const input = document.createElement("input");
        input.setAttribute("type", "checkbox");
        input.setAttribute("contracts", "checkbox");
        input.setAttribute("id", contract.Uri);
        input.setAttribute("data-label", contract.Label);
        input.checked = !!contract.Selected;

        const label = document.createElement("label");
        label.setAttribute("for", contract.Uri);
        label.innerText = contract.Label;

        this.contractsContainer.appendChild(input);
        this.contractsContainer.appendChild(label);
      });
    }
    
    this.contractValidator = getSingleInstanceByElement("ValidatedCheckBoxGroup", this.contractsContainer)
    this.contractValidator.initialize();

    this.contractsContainer.querySelectorAll('input[type=checkBox]').forEach((input : HTMLInputElement) => {
      input.addEventListener('change', () => {this.contractValidator.check()})
    })



    this.firstnameValidator = getSingleInstanceByElement("ValidatedInput", this.firstname);
    this.nameValidator = getSingleInstanceByElement("ValidatedInput", this.name);
    this.emailValidator = getSingleInstanceByElement("ValidatedInput", this.email);
    this.localityValidator = getSingleInstanceByElement("ValidatedInput", this.locality.getElement());

    this.saveButton.addEventListener("click", () => {
      this.check();
    });

    this.element.classList.add("loaded");
  }
  check(): void {
    this.firstnameValidator.check();
    this.nameValidator.check();
    this.emailValidator.check();
    this.contractValidator.check();
    this.localityValidator.check();

    const cgu = <HTMLInputElement>document.getElementById("cgu")
    const cguError = <HTMLSpanElement>document.getElementById("cgu-error")
    if (!cgu.checked) {
      cguError.classList.replace("tw-hidden", "tw-flex")
    }

    let isValid = this.password.check();
    isValid = this.job.check() && isValid;

    if (
      isValid &&
      this.firstnameValidator.isValid() &&
      this.nameValidator.isValid() &&
      this.emailValidator.isValid() &&
      this.contractValidator.isValid() &&
      this.localityValidator.isValid() &&
      cgu.checked
    ) {
      this.save()
    }
  }
  displayError(message?: string): void {
    const messageDefault = message ? message : "Aïe, une erreur est survenue, rechargez la page et réessayez."
    notifyFromAlert(
      {
        Icon: 2,
        Message: messageDefault,
        AnalyticsTrackings: "",
        sticky: true,
      },
      true
    );
  }
  save(): void {
    const service = new SignUpService(this.props.url);
    const data = { dto: this.getFields() };
    this.saveButton.classList.add("disabled");
    const simpleProgressInstance = getSingleInstanceByElement(
        "SimpleProgress",
        this.saveButton
    );
    simpleProgressInstance.start();
    service.post(data, (response:any) => {
      if (response.isSucceeded) {
        document.dispatchEvent(new CustomEvent(ACCOUNT_CREATION_SUCCESS, {
            detail: {
                userEmail : response.email,
            },
          })
        );

        simpleProgressInstance.stop();

        if (response.trackingLoads) {
          const trackingEvents = JSON.parse(response.trackingLoads);

          trackingEvents.map(function (trackingEvent: any) {
            window.dataLayer.push(trackingEvent);
          });
        }

      } else {
        this.password.clear();
        simpleProgressInstance.stop();
        this.saveButton.classList.remove("disabled");
        this.signIn.setEmail(this.email.value);
        this.displayError(response.message);
      }
    })
  }
  setEmail(email: string): void {
    this.email.value = email;
  }
  getFields() {
    return {
      "firstname": this.firstname.value,
      "name": this.name.value,
      "email": this.email.value,
      "password": this.password.getValue(),
      "job": {
          "label": this.job.getValue().job,
          "uri": this.job.getValue().job_autocomplete
      },
      "locations": this.locality.getCriterionFormatValues(),
      "contractTypes" : this.contractValidator.getValue()
    };
  }
}
